"use client";

import { Suspense } from "react";
import { useNewsFilter } from "@/app/(site)/_hooks/useNewsFilter";
import UserActions from "./UserActions";
import Loader from "../../utils/loader/Loader";
import { NewsPageQueryResult } from "@/sanity.types";
import NewsDisplay from "./NewsDisplay";

type NewsContainerProps = {
	pageData: NonNullable<NewsPageQueryResult>;
};

function NewsContent({ pageData }: NewsContainerProps) {
	const { filteredNews, availableCategories, activeCategoryId, handleCategoryChange } = useNewsFilter({
		news: pageData.orderOfNewsList,
		categories: pageData.newsCategories,
	});

	const totalNewsCount = pageData.orderOfNewsList.length;

	return (
		<>
			<div className="col-span-2 sm:col-span-3">
				<div className="sm:sticky sm:top-40">
					<h1 className="text-h5 sm:text-h4 text-graphite-black mb-3">{pageData.headline}</h1>
					<p className="text-body-m sm:text-body-s text-graphite-black/70 mb-7.5 whitespace-pre-wrap sm:mb-10">
						{pageData.description}
					</p>
					<UserActions
						newsCategories={availableCategories}
						totalNewsCount={totalNewsCount}
						activeCategoryId={activeCategoryId}
						onCategoryChange={handleCategoryChange}
					/>
				</div>
			</div>

			<div className="col-span-2 mt-5 sm:col-span-9 sm:col-start-4 sm:mt-0">
				<NewsDisplay news={filteredNews} />
			</div>
		</>
	);
}

export default function NewsContainer({ pageData }: NewsContainerProps) {
	return (
		<div id="newsGrid" className="grid grid-cols-2 gap-x-5 sm:grid-cols-12">
			<Suspense
				fallback={
					<div className="col-span-2 flex h-96 items-center justify-center sm:col-span-12">
						<Loader className="h-[15vh]" />
					</div>
				}
			>
				<NewsContent pageData={pageData} />
			</Suspense>
		</div>
	);
}
